import { RefreshCw } from 'lucide-react'
import { Banner } from './Banner'

export interface StaleDraftBannerProps {
  onReload: () => void
}

// Shown by a screen whose server data changed while it held unsaved edits
// (hooks/useServerSeed.ts `baseChanged`). Save stays disabled until the user
// reloads, so the edits can never be written over the newer data.
export const STALE_DRAFT_SAVE_REASON = 'Reload the latest version before saving'

export function StaleDraftBanner({ onReload }: StaleDraftBannerProps) {
  return (
    <Banner
      variant="warning"
      icon={RefreshCw}
      title="This changed elsewhere"
      action={{ label: 'Reload', onClick: onReload }}
    >
      This file was changed or discarded elsewhere (for example in Diff & Validation). Reload to see
      the current version; your unsaved changes here will be lost.
    </Banner>
  )
}
